export default "__VITE_ASSET__B3mw_iH4__"